module.exports = __webpack_public_path__ + "static/media/YesicaCynthiaViverosLopez.70ebb845.png";